import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
} from "@mui/material";
import Fuse from "fuse.js";
import React, { useState } from "react";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { v4 as uuid } from "uuid";
import { AddUserPermissionResponse } from "../../../models/userPermission.model";
import { DeleteUserPermission } from "../../../services/userPermissions.service";
import CertificateTableRows from "./CertificateTableRows";

const columns = [
  {
    id: 1,
    title: "نام مجوز",
  },

  {
    id: 2,
    title: "گروه مجوز",
  },
];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#34495E",
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  userPermissionsList: AddUserPermissionResponse[];
  setUpdateGetUserPermissions: any;
  searchTerm: string;
}
const PermisssionCertificateTable = ({
  userPermissionsList,
  setUpdateGetUserPermissions,
  searchTerm,
}: Props) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [delId, setDelId] = useState<number>();
  const [isHovered, setHovered] = useState(false);

  const handelDeleteItem = () => {
    DeleteUserPermissionMutate({
      userPermissionId: delId!,
    });
  };

  const fuse = new Fuse(userPermissionsList, {
    keys: ["permissionTitle"],
    includeScore: true,
    threshold: 0.1,
    ignoreLocation: true,
    useExtendedSearch: true,
  });
  const results = fuse.search(searchTerm);
  const searchResults = searchTerm
    ? results.map((title) => title.item)
    : userPermissionsList;

  const { mutate: DeleteUserPermissionMutate } = useMutation(
    DeleteUserPermission,
    {
      onSuccess: (data: boolean) => {
        if (data) {
          setUpdateGetUserPermissions(uuid());
          toast.success("با موفقیت حذف گردید");
          setOpenDeleteModal(false);
        }
      },
      onError: () => {},
    }
  );

  return (
    <>
      <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
        <Table
          stickyHeader
          sx={{ minWidth: { xs: 0, sm: 0, md: 700, lg: 900 } }}
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              {columns.length > 0 &&
                columns.map((column) => (
                  <StyledTableCell align="center">
                    {column.title}
                  </StyledTableCell>
                ))}
              <StyledTableCell align="center">
                <MoreHorizIcon />
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              outline: "1px solid #DAE0E4",
            }}
          >
            {userPermissionsList?.length !== 0 &&
              searchResults
                ?.map((permisson: AddUserPermissionResponse, index: number) => (
                  <>
                    <CertificateTableRows
                      permisson={permisson}
                      setUpdateGetUserPermissions={setUpdateGetUserPermissions}
                    />
                  </>
                ))
                .reverse()}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default PermisssionCertificateTable;
